import {CookiePolicy as cookiePolicy} from "./cookiePolicy";
import alertUtils from "./utils";

export function parseJwt(token) {
    if (!token) {
        return null;
    }

    try {
        const base64Url = token.split(".")[1];
        if (!base64Url) {
            return null;
        }

        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            window.atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );

        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error("parseJwt error", e);
        return null;
    }
}

export async function checkTokenAsync(token) {
    const res = await fetch(`${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/check`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (res.status === 200) {
        const newToken = await res.text();
        saveAccessToken(newToken);
        return newToken;
    }

    if (res.status === 401) {
        await alertUtils.warningWithCallback(
            "로그인이 만료 되었습니다.",
            () => window.location.replace("/")
        );

        return null;
    }

    throw new Error("Token check failed");
}

function normalizeToken(token) {
    return token?.replace(/^"(.*)"$/, "$1").trim();
}

function saveAccessToken(token) {
    token = normalizeToken(token);

    const keepLogin = cookiePolicy.getCookie("keepLogin") === "Y";

    if (keepLogin) {
        cookiePolicy.setCookie("accessToken", token, 30);
    } else {
        cookiePolicy.setCookie("accessToken", token);
    }
}

let refreshPromise = null;

export async function getTokenAsync() {
    let token = normalizeToken(cookiePolicy.getCookie("accessToken"));

    if (!token) {
        alertUtils.info("로그인이 필요합니다.");
        window.location.href = "/";
        throw new Error("No token");
    }

    const jwtPayload = parseJwt(token);
    const now = Math.floor(Date.now() / 1000);

    if (jwtPayload && jwtPayload.exp > now) {
        return `Bearer ${token}`;
    }

    if (refreshPromise) {
        return refreshPromise;
    }

    refreshPromise = checkTokenAsync(token)
        .then((newToken) => `Bearer ${newToken}`)
        .finally(() => {
            refreshPromise = null;
        });

    return refreshPromise;
}

export async function updateTokenAsync(service) {
    let token = normalizeToken(cookiePolicy.getCookie("accessToken"));
    try {
        const response = await fetch(
            `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/check?service=${encodeURIComponent(service)}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${token}`
                }
            }
        );

        if (response.status === 200) {
            const token = await response.text();
            saveAccessToken(token);
            return token;
        }

        if (response.status === 401) {
            await alertUtils.warningWithCallback("로그인이 만료 되었습니다.", window.location.href = "/");
            return null;
        }

        return null;
    } catch (error) {
        console.error("updateToken error:", error);
        return null;
    }
}